"use client";
import type {Page} from "../types";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import React, {FormEvent, useContext, useEffect, useRef, useState} from "react";
import {LayoutContext} from "../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {ConfirmPopup} from "primereact/confirmpopup";
import {useNavigate} from "react-router-dom";
import callToast from "../utils/helper";
import {webInfo} from "../utils/webInfo";
import {Checkbox} from "primereact/checkbox";

const Login: Page = () => {
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
    const {layoutConfig, setAccessToken} = useContext(LayoutContext);
    const toast = useRef<Toast | null>(null);
    const dark = layoutConfig.colorScheme !== "light";
    const [loginData, setLoginData] = useState<{ [key: string]: string; }>()
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => {
        const isLogin: any = localStorage?.getItem("isLogin");
        if (+isLogin === 1) {
            navigate("/")
        }
    }, [navigate])

    // handle Login data
    const handleLoginData = (name: string, value: string) => {
        setLoginData({...loginData, [name]: value})
    }


    const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (!loginData?.username) {
            return callToast(toast, false, "Username is required.")
        }
        if (!loginData?.password) {
            return callToast(toast, false, "Password is required.")
        }


        const formData = new FormData();
        formData.append('userName', loginData.username)
        formData.append('password', loginData.password)

        const loginPayload: any = {
            email: loginData?.username,
            password: loginData?.password,
        }
        // console.log('loginData: ', loginPayload)
        try {
            setIsLoading(true);
            const res = await fetch(`${webInfo.baseUrl}/login`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json"
                },
                body: JSON.stringify(loginPayload),
                // body: loginPayload,
                // credentials: "include",
                // body: formData,
            });
            // console.log('res: ', res)
            const resData = await res.json();
            if (res.ok) {
                localStorage.setItem("isLogin", "1");
                setAccessToken(resData?.data?.token?.token)
                // router.push("/");
                navigate('/')
            } else {
                callToast(toast, false, resData.errors[0]);
            }
        } catch (error: any) {
            callToast(toast, "warn", error?.message);
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <>
            <Toast ref={toast}/>
            <ConfirmPopup/>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1600 800"
                className="fixed left-0 top-0 min-h-screen min-w-screen"
                preserveAspectRatio="none"
            >
                <rect
                    fill={dark ? "var(--primary-900)" : "var(--primary-500)"}
                    width="1600"
                    height="800"
                />
                <path
                    fill={dark ? "var(--primary-800)" : "var(--primary-400)"}
                    d="M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z"
                />
                <path
                    fill={dark ? "var(--primary-700)" : "var(--primary-300)"}
                    d="M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z"
                />
                <path
                    fill={dark ? "var(--primary-600)" : "var(--primary-200)"}
                    d="M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z"
                />
                <path
                    fill={dark ? "var(--primary-500)" : "var(--primary-100)"}
                    d="M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z"
                />
            </svg>
            <form
                onSubmit={handleLogin}
                className="px-5 min-h-screen flex justify-content-center align-items-center">

                <div className="border-1 surface-border surface-card border-round py-7 px-4 md:px-7 z-1">

                    {/*Company Logo*/}
                    {/*<div className={"flex justify-content-center mb-4"}>*/}
                    {/*    <img src="/logo-symbol.png" alt="Logo" className={"w-auto h-5rem"}/>*/}
                    {/*</div>*/}


                    <div className="flex flex-column">
                        <span className="p-input-icon-left w-full mb-4">
                            <i className="pi pi-user"></i>
                            <InputText
                                id="email"
                                type="text"
                                className="w-full md:w-25rem"
                                placeholder="Username"
                                onChange={(e) => handleLoginData("username", e.target.value)}
                            />
                        </span>

                        <span className="p-input-icon-left p-input-icon-right w-full mb-4">
                            <i className="pi pi-lock"></i>
                            <InputText
                                id="password"
                                type={showPassword ? "text" : "password"}
                                autoComplete={"on"}
                                className="w-full md:w-25rem"
                                placeholder="Password"
                                onChange={(e) => handleLoginData("password", e.target.value)}
                            />
                                    <i
                                        className={`pi ${showPassword ? "pi-eye" : "pi-eye-slash"} text-xl mr-2`}
                                        onClick={() => setShowPassword(!showPassword)}></i>
                        </span>
                        <div className="mb-4 flex flex-wrap gap-3">
                            <div>
                                <Checkbox
                                    name="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) =>
                                        setRememberMe(e.checked ?? false)
                                    }
                                    className="mr-2"
                                ></Checkbox>
                                <label
                                    htmlFor="checkbox"
                                    className="text-900 font-medium mr-8"
                                >
                                    Remember Me
                                </label>
                            </div>
                            <a className="text-600 cursor-pointer hover:text-primary cursor-pointer ml-auto transition-colors transition-duration-300">
                                Reset password
                            </a>
                        </div>
                        <Button
                            label="Log In"
                            className="w-full"
                            loading={isLoading}
                        ></Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default Login;
